import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { AuthShell, IconInput } from "./AuthShell";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck, Mail } from "lucide-react";
import { isValidEmail } from "../lib/validate";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!isValidEmail(email)) { setError("Enter a valid email address."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <AuthShell>
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        {done ? (
          <div className="text-center" data-testid="forgot-done">
            <MailCheck className="h-12 w-12 text-emerald-500 mx-auto" />
            <h2 className="font-heading text-2xl font-bold text-slate-900 mt-4">Check your email</h2>
            <p className="text-sm text-slate-500 mt-2">{done}</p>
            <Button asChild className="mt-6 bg-[#1E3A8A] hover:bg-[#1D4ED8]">
              <Link to="/login">Back to Sign In</Link>
            </Button>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-2xl font-bold text-slate-900">Forgot password</h2>
            <p className="text-sm text-slate-500 mt-1">
              Enter your email and we’ll send you a reset link.
            </p>
            {error && (
              <div data-testid="forgot-error" className="mt-4 text-sm bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2">{error}</div>
            )}
            <form onSubmit={submit} noValidate className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <IconInput icon={Mail} id="email" data-testid="forgot-email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="you@silastech.com" />
              </div>
              <Button type="submit" data-testid="forgot-submit" disabled={loading}
                className="w-full bg-[#1E3A8A] hover:bg-[#1D4ED8] h-11">
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Send Reset Link
              </Button>
            </form>
            <p className="mt-6 text-sm text-center text-slate-500">
              <Link to="/login" className="text-blue-700 font-semibold hover:underline">Back to Sign In</Link>
            </p>
          </>
        )}
      </div>
    </AuthShell>
  );
}
